import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useSettings } from "../context/SettingsContext";
import { useLang } from "../context/LanguageContext";
import { SOCIAL_NETWORKS } from "../lib/socials";

export default function Footer() {
  const { settings } = useSettings();
  const { t } = useLang();
  const activeSocials = SOCIAL_NETWORKS.filter((s) => (settings[s.key] || "").trim());
  return (
    <footer className="border-t border-white/10 bg-void" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink-secondary">
              {t("ft_tagline")}
            </p>
            <p className="mt-6 font-display text-lg text-white">
              {t("ft_line1")}<br /><span className="text-cyan">{t("ft_line2")}</span>
            </p>
            <a href="mailto:contact@appchallengeacademy.com" className="mt-5 inline-block text-sm text-ink-secondary transition-colors hover:text-cyan" data-testid="footer-email">
              contact@appchallengeacademy.com
            </a>
            {activeSocials.length > 0 && (
              <div className="mt-6 flex flex-wrap gap-2.5" data-testid="footer-socials">
                {activeSocials.map((s) => (
                  <a key={s.key} href={settings[s.key]} target="_blank" rel="noopener noreferrer" title={s.label} data-testid={`footer-social-${s.key}`}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-ink-secondary transition-all hover:-translate-y-0.5 hover:border-cyan hover:text-cyan">
                    <s.icon size={16} />
                  </a>
                ))}
              </div>
            )}
          </div>
          <div>
            <div className="mb-4 text-[11px] uppercase tracking-[0.2em] text-ink-tertiary">{t("ft_nav")}</div>
            <ul className="space-y-2.5 text-sm text-ink-secondary">
              <li><Link className="hover:text-cyan" to="/">{t("nav_home")}</Link></li>
              {settings.nav_how && <li><Link className="hover:text-cyan" to="/comment-ca-marche">{t("nav_how")}</Link></li>}
              {settings.nav_challenge && <li><Link className="hover:text-cyan" to="/challenge">{t("nav_challenge")}</Link></li>}
              {settings.nav_gallery && <li><Link className="hover:text-cyan" to="/applications">{t("nav_gallery")}</Link></li>}
            </ul>
          </div>
          <div>
            <div className="mb-4 text-[11px] uppercase tracking-[0.2em] text-ink-tertiary">{t("ft_account")}</div>
            <ul className="space-y-2.5 text-sm text-ink-secondary">
              <li><Link className="hover:text-cyan" to="/connexion">{t("nav_login")}</Link></li>
              <li><Link className="hover:text-cyan" to="/inscription">{t("ft_signup")}</Link></li>
              <li><Link className="hover:text-cyan" to="/partenaire" data-testid="footer-partner">{t("ft_partner")}</Link></li>
              <li><a className="hover:text-cyan" href="#contact">{t("ft_contact")}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-ink-tertiary sm:flex-row sm:items-center">
          <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>© {new Date().getFullYear()} APP CHALLENGE ACADEMY — appchallengeacademy.com</span>
            <span className="text-white/20">·</span>
            <Link to="/cgu" className="underline-offset-2 transition-colors hover:text-cyan hover:underline" data-testid="footer-cgu">CGU</Link>
            <span className="text-white/20">·</span>
            <Link to="/mentions-legales" className="underline-offset-2 transition-colors hover:text-cyan hover:underline" data-testid="footer-legal">Mentions légales</Link>
          </span>
          <span className="font-display uppercase tracking-widest">{t("ft_signature")}</span>
        </div>
      </div>
    </footer>
  );
}
